import React from 'react';
import { SECURITY_ACTIONS } from '../../../auth/Security';
import { SIDE_PANEL_IDS } from '../../../constants/constants';
import I18n from '../../../i18n/I18n';
import { Icons } from '../../../icons/Icons';
import type { SidePanelDeclaration, SidePanelDefinition, SidePanelPresetConfiguration } from '../../types';
import { AttachmentsSidePanel } from './AttachmentsSidePanel';

const definition: SidePanelDefinition = {
    id: SIDE_PANEL_IDS.attachments,
    kind: 'entity',
    icon: Icons.Attachments,
    label: <I18n token="attachments.title" />,
    affordancePermission: { securityAction: SECURITY_ACTIONS.COMMENT },
    deepLink: { mode: 'linkedNode', nodeKey: 'attachment' },
    Component: AttachmentsSidePanel
};

export function attachmentsPanel(declarationConfiguration: SidePanelPresetConfiguration = {}): SidePanelDeclaration {
    const declaration: SidePanelDeclaration = {
        definition: { ...definition, ...declarationConfiguration.definition },
        hidden: declarationConfiguration.hidden,
        enabled: declarationConfiguration.enabled,
        options: declarationConfiguration.options
    };
    return declaration;
}
